import React, { useState, useEffect, useRef } from 'react';
import { FiServer, FiUsers, FiGlobe, FiSun, FiMoon, FiChevronDown, FiLogIn, FiZap } from 'react-icons/fi';
import './App.css';

const API_URL = 'http://185.249.198.189:3000/get_status';
const ROBLOX_PLACE_ID = '93557641472236';
const POLLING_INTERVAL_MS = 3000;
const FAILURE_THRESHOLD = 3;

const getDayNightStatus = (decimalTime) => {
  if (decimalTime >= 5 && decimalTime < 7) return { status: 'Sunrise', icon: <FiSun /> };
  if (decimalTime >= 7 && decimalTime < 18) return { status: 'Day', icon: <FiSun /> };
  if (decimalTime >= 18 && decimalTime < 20) return { status: 'Sunset', icon: <FiMoon /> };
  return { status: 'Night', icon: <FiMoon /> };
};

const ServerRow = ({ server }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const joinUrl = `https://www.roblox.com/games/start?placeId=${ROBLOX_PLACE_ID}&gameInstanceId=${server.jobId}`;

  return (
    <>
      <tr className="server-row" onClick={() => setIsExpanded(!isExpanded)}>
        <td>{server.id}</td>
        <td>
          <span className="player-count">
            {server.playerCount} / 6
            <FiChevronDown className={`chevron-icon ${isExpanded ? 'expanded' : ''}`} />
          </span>
        </td>
        <td>
          <a href={joinUrl} target="_blank" rel="noopener noreferrer" className="join-button" onClick={(e) => e.stopPropagation()}>
            <FiLogIn /> Join
          </a>
        </td>
      </tr>
      {isExpanded && (
        <tr className="player-list-row">
          <td colSpan="3">
            <div className="player-list">
              {server.players.length > 0 ? (
                server.players.map(player => <span key={player} className="player-tag">{player}</span>)
              ) : (
                <span className="no-players-tag">No players in this server.</span>
              )}
            </div>
          </td>
        </tr>
      )}
    </>
  );
};

const ServerList = ({ servers }) => (
  <div className="server-list-container">
    <div className="server-list-header"><h3>Active Servers</h3></div>
    <div className="server-list-table-wrapper">
      <table>
        <thead><tr><th>Server ID</th><th>Players</th><th>Action</th></tr></thead>
        <tbody>
          {servers.length > 0 ? (
            servers.map(server => <ServerRow key={server.id} server={server} />)
          ) : (
            <tr><td colSpan="3">No active servers detected.</td></tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
);

function App() {
  const [status, setStatus] = useState({
    gameTime: '00:00', gameTimeDecimal: 0, serverUptime: '0:00:00',
    totalServers: 0, totalPlayers: 0, serverList: []
  });
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState('dashboard');
  const failureCountRef = useRef(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(API_URL);
        if (!response.ok) throw new Error(`API returned status: ${response.status}`);
        const data = await response.json();
        setStatus(data);
        failureCountRef.current = 0;
        if (error) setError(null);
      } catch (err) {
        failureCountRef.current += 1;
        if (failureCountRef.current >= FAILURE_THRESHOLD) {
          setError('Failed to connect to the Time API.');
        }
      }
    };
    fetchData();
    const intervalId = setInterval(fetchData, POLLING_INTERVAL_MS);
    return () => clearInterval(intervalId);
  }, [error]);

  const dayNightInfo = getDayNightStatus(status.gameTimeDecimal);

  return (
    <div className="dashboard-container">
      <header className="dashboard-header">
        <h1>Time Authority Dashboard</h1>
        <div className={`status-indicator ${error ? 'error' : 'live'}`}>
          <div className="status-dot"></div>{error ? 'OFFLINE' : 'LIVE'}
        </div>
      </header>
      <nav className="nav-tabs">
        <button onClick={() => setActiveTab('dashboard')} className={activeTab === 'dashboard' ? 'active' : ''}><FiGlobe /> Dashboard</button>
        <button onClick={() => setActiveTab('servers')} className={activeTab === 'servers' ? 'active' : ''}><FiServer /> Servers</button>
      </nav>
      {error ? <div className="error-message">{error}</div> : (
        <main>
          {activeTab === 'dashboard' && (
            <>
              <div className="hero-card">
                <div className="day-night-status">{dayNightInfo.icon}<span>{dayNightInfo.status}</span></div>
                <div className="hero-time">{status.gameTime}</div>
                <div className="progress-bar-container"><div className="progress-bar-fill" style={{ width: `${(status.gameTimeDecimal / 24) * 100}%` }}></div></div>
                <div className="card-subtitle">({status.gameTimeDecimal} / 24.00)</div>
              </div>
              <div className="stats-grid">
                <div className="stat-card"><div className="icon-wrapper"><FiUsers /></div><div className="card-content"><div className="card-title">TOTAL PLAYERS</div><div className="card-value">{status.totalPlayers}</div></div></div>
                <div className="stat-card"><div className="icon-wrapper"><FiServer /></div><div className="card-content"><div className="card-title">ACTIVE SERVERS</div><div className="card-value">{status.totalServers}</div></div></div>
                <div className="stat-card"><div className="icon-wrapper"><FiZap /></div><div className="card-content"><div className="card-title">API UPTIME</div><div className="card-value">{status.serverUptime}</div></div></div>
              </div>
            </>
          )}
          {activeTab === 'servers' && <ServerList servers={status.serverList} />}
        </main>
      )}
    </div>
  );
}

export default App;